import type { Release } from '../releases';

export default {
  id: '2026-11-02-contract-execution',
  at: '2026-11-03T05:30:00Z',
  title: 'Исполнение договора поставки: поставлено, оплачено, просрочки и неустойка',
  modules: ['contracts'],
  items: [
    'В карточке подписанного договора поставки — панель «Исполнение договора»: сколько поставлено и сколько осталось поставить, сколько оплачено и сколько к оплате, что осталось по каждой позиции.',
    'Поставки, срок которых по графику прошёл, показаны с днями просрочки и стоимостью непоставленного; они же попадают в «Ждёт меня» тем, кто ведёт договоры проекта.',
    'В проекте договора задаётся неустойка за просрочку поставки — процент в день от непоставленного и предел от суммы договора. Портал считает неустойку сам.',
    'Без доступа к суммам договоров видны количества и дни просрочки, суммы скрыты.',
  ],
  why: 'Чтобы увидеть, что поставщик срывает сроки и сколько он должен по неустойке, приходилось сводить склад, график и оплаты вручную.',
  link: '/contracts',
} satisfies Release;
